import { useTranslation } from 'react-i18next'

import { ComboBox, Text } from '@reveni-io/reveni-ui'

import { userPermissions } from '@/common/constants'
import useUserPermissions from '@/common/hooks/useUserPermissions/useUserPermissions'
import { providers } from '@/returns/constants'

import { getLocations } from './helpers'
import * as Styles from './styles'

const ManageRestock = ({
  value,
  onChange,
  locations = [],
  onChangeLocation,
  selectedLocation,
  provider,
  storeId,
  title,
  restockLabel,
  noRestockLabel,
}) => {
  const { t } = useTranslation()
  const { hasPermission } = useUserPermissions()

  if (!hasPermission(userPermissions.restockProducts, storeId)) return null

  return (
    <Styles.Container>
      <Styles.Title>
        <Text type="titleS">{title || t('Reposición productos devueltos:')}</Text>
      </Styles.Title>
      <div>
        <ComboBox
          fullWidth
          label={t('Reposición de productos')}
          handleChange={e => onChange(e.target.value === 'restock' ? true : false)}
          value={value ? 'restock' : 'no_restock'}
          menuItems={[
            { label: restockLabel || t('Reponer productos aceptados'), value: 'restock' },
            { label: noRestockLabel || t('Dejar productos aceptados sin reponer'), value: 'no_restock' },
          ]}
        />
      </div>
      <div>
        {value && [providers.shopify, providers.centra, providers.bigcommerce].includes(provider) && (
          <ComboBox
            label={t('Ubicación')}
            value={selectedLocation}
            handleChange={onChangeLocation}
            menuItems={getLocations(locations)}
            placeholder={t('Seleccionar sucursal')}
            fullWidth
            disabled={locations?.length === 1}
          />
        )}
      </div>
    </Styles.Container>
  )
}

export default ManageRestock
